<template>
  <div>
    <section-title
      icon="fas fa-file-user"
      container-class="tag-badge-main-info mt-2 mb-2"
      content="Area: Destrezas académicas dirigidas a la instrucción postsecundaria"
    />
    <section-title content="Acomodos Razonables Utilizados" has-line />
    <div
      v-for="(area, key) in data.areas"
      :key="key"
      class="area-item mt-3 rounded "
    >
      <div
        class="d-flex justify-content-between shadow-sm px-3 py-1 mb-2 rounded"
        :class="{
          displayed: area.displayed
        }"
      >
        <div class="mt-1">
          <a
            data-toggle="collapse"
            :href="`#${areaItemId(key)}`"
            role="button"
            aria-expanded="false"
            aria-controls="multiCollapseExample1"
            class="area-item-collapse-button bg-white rounded-circle mr-2 "
            :class="{
              'fas fa-angle-down text-success': area.displayed,
              'fas fa-angle-right text-orange': !area.displayed
            }"
            @click="display(area)"
          ></a>
          <span class="fs-16 font-weight-bold">{{ area.title }}</span>
        </div>
      </div>
      <div :id="areaItemId(key)" class="collapse multi-collapse mt-4">
        <div
          v-for="(accomodation, aKey) in area.accomodations"
          :key="aKey"
          class="p-4 my-3 bg-gray rounded"
        >
          {{ accomodation.name }}
        </div>
      </div>
    </div>
    <div class="py-4 d-flex justify-content-end">
      <action-button
        type="button"
        text="Continuar"
        i="fas fa-arrow-alt-circle-right"
        variant="success"
        @click="next"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import SectionTitle from "SectionTitle";
export default {
  name: "ReasonableAccommodations",
  components: {
    ActionButton,
    SectionTitle
  },
  props: {
    data: {
      type: Object,
      dafault: () => ({ areas: [] })
    },
    value: {
      type: Object,
      dafault: () => ({})
    }
  },
  data: () => ({}),
  computed: {
    areaItemId: () => key => `transition-student-profile-area-collapse-${key}`
  },
  methods: {
    async validate() {
      return { valid: true, message: "" };
    },
    next() {
      this.$emit("next", this.value);
    },
    display(area) {
      area.displayed = !area.displayed;
      this.$forceUpdate();
    }
  }
};
</script>
<style scoped lang="scss">
.area-item > div:first-child {
  background-color: #cbd6d1;
  border-radius: 0.25rem 0.25rem 0px 0px;
}
.fs-16 {
  font-size: 16px;
}
.area-item-collapse-button {
  height: 24px;
  width: 24px;
  text-align: center;
  padding-top: 2px;
  margin-bottom: 4px;
  border: 2px solid white;
  cursor: pointer;
  text-decoration: none;
}
.area-item-collapse-button.fa-check {
  padding-top: 5px !important;
}
</style>
